'use strict';

const workpackageBusinessUnits = ['dairy'];

module.exports = {
  DAIRY: workpackageBusinessUnits[0],
  ALL: workpackageBusinessUnits,
};
